import { InjectionToken } from "@angular/core";
import { Resolve } from "@angular/router";
import { IPage } from "@zaeper/communication-lib";
import { IWidgetVersion } from "src/app/models/application-version/i-widget-version";

export const widgetVersionPageResolverInjectionToken: InjectionToken<Resolve<IPage<IWidgetVersion>>> = new InjectionToken<Resolve<IPage<IWidgetVersion>>>( "digital-signage-developer-dashboard.WidgetVersionPageResolver" );
